/*
 * Author page archive: chip filter and sort.
 *
 * Enhancement only. Every card and link is already in the server-rendered
 * HTML (snippets/author-archive.liquid), grouped by category, and works with
 * JavaScript off. This script never removes the original cards: filtered
 * and sorted views are built from clones in a separate flat list.
 */
(function () {
  'use strict';

  var archive = document.querySelector('[data-author-archive]');
  if (!archive) return;
  var controls = archive.querySelector('[data-author-controls]');
  var groups = archive.querySelector('[data-author-groups]');
  var flat = archive.querySelector('[data-author-flat]');
  if (!controls || !groups || !flat) return;

  var cards = Array.prototype.slice.call(groups.querySelectorAll('[data-author-card]'));
  var chips = Array.prototype.slice.call(controls.querySelectorAll('[data-chip]'));
  var state = { category: '', sort: 'newest' };

  var sortLabels = {
    newest: 'Newest first',
    reviewed: 'Recently reviewed',
    az: 'A to Z'
  };

  // Sort control.
  var sortWrap = document.createElement('label');
  sortWrap.className = 'author_sort';
  sortWrap.appendChild(document.createTextNode('Sort'));
  var select = document.createElement('select');
  Object.keys(sortLabels).forEach(function (key) {
    var option = document.createElement('option');
    option.value = key;
    option.textContent = sortLabels[key];
    select.appendChild(option);
  });
  sortWrap.appendChild(select);
  controls.appendChild(sortWrap);

  // "N in Category · Clear" line.
  var status = document.createElement('p');
  status.className = 'p is--small author_status';
  status.setAttribute('aria-live', 'polite');
  status.hidden = true;
  controls.appendChild(status);

  function matches(card) {
    if (!state.category) return true;
    return (' ' + card.getAttribute('data-categories') + ' ').indexOf(' ' + state.category + ' ') > -1;
  }

  function compare(a, b) {
    if (state.sort === 'az') {
      return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
    }
    var attr = state.sort === 'reviewed' ? 'data-reviewed' : 'data-published';
    return Number(b.getAttribute(attr)) - Number(a.getAttribute(attr));
  }

  function chipLabel(handle) {
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('data-chip') === handle) {
        return chips[i].textContent.replace(/\s*\(\d+\)\s*$/, '');
      }
    }
    return '';
  }

  function render() {
    chips.forEach(function (chip) {
      var active = chip.getAttribute('data-chip') === state.category;
      chip.classList.toggle('is--active', active);
      if (active) chip.setAttribute('aria-current', 'true');
      else chip.removeAttribute('aria-current');
    });

    var useFlat = state.category !== '' || state.sort !== 'newest';
    groups.hidden = useFlat;
    flat.hidden = !useFlat;
    flat.innerHTML = '';

    if (!useFlat) {
      status.hidden = true;
      return;
    }

    var list = cards.filter(matches).sort(compare);
    list.forEach(function (card) {
      flat.appendChild(card.cloneNode(true));
    });

    var text = state.category
      ? list.length + ' in ' + chipLabel(state.category)
      : 'All ' + list.length + ' articles, ' + sortLabels[state.sort].toLowerCase();
    status.textContent = text + ' · ';
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.textContent = 'Clear';
    clear.addEventListener('click', reset);
    status.appendChild(clear);
    status.hidden = false;
  }

  function reset() {
    state = { category: '', sort: 'newest' };
    select.value = 'newest';
    render();
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function (event) {
      event.preventDefault();
      // webflow.js smooth-scrolls every #link from a document-level handler. The
      // chip's target group is hidden by render(), so it would scroll to the top.
      event.stopPropagation();
      state.category = chip.getAttribute('data-chip');
      render();
      archive.scrollIntoView({ block: 'start' });
    });
  });

  select.addEventListener('change', function () {
    state.sort = select.value;
    render();
  });
})();
